/**
 * @module FieldControls
 */
import { FormHelperText, InputAdornment, TextField, Typography } from '@material-ui/core';
import { deepMerge, toNumber } from '@sensenet/client-utils';
import { isCurrencyFieldSetting } from '@sensenet/default-content-types';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a Number field. Available values will be populated from the FieldSettings.
 */
export const NumberField = props => {
  var _props$localization;
  const localization = deepMerge(defaultLocalization.number, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.number);
  const initialState = props.fieldValue != null ? props.fieldValue : props.actionName === 'new' && props.settings.DefaultValue !== undefined && Number.parseInt(changeTemplatedValue(props.settings.DefaultValue), 10) || undefined;
  const [value, setValue] = useState(initialState);
  const handleChange = e => {
    var _props$fieldOnChange;
    const inputValue = e.target.value.replace(/[^0-9.,]/g, '');
    setValue(inputValue);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, e.target.value);
  };
  /**
   * Returns steps value by decimal and step settings
   */
  const defineStepValue = () => {
    if (props.settings.Step) {
      return props.settings.Step;
    }
    if (!props.fieldValue) {
      return 1;
    }
    return Number.isInteger(toNumber(props.fieldValue)) || props.settings.Type === 'IntegerFieldSetting' ? 1 : 0.1;
  };

  /**
   * Returns inputadornment by currency
   */
  const defineCurrency = () => {
    if (isCurrencyFieldSetting(props.settings) && props.settings.Format) {
      return /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, props.settings.Format);
    }
    return null;
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
        style: {
          width: '100%'
        },
        autoFocus: props.autoFocus,
        name: props.settings.Name,
        type: "text",
        label: props.settings.DisplayName,
        value: value,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        placeholder: "0",
        InputLabelProps: {
          shrink: true
        },
        InputProps: {
          startAdornment: defineCurrency(),
          endAdornment: props.settings.ShowAsPercentage ? /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, "%") : null
        },
        inputProps: {
          step: defineStepValue(),
          max: props.settings.MaxValue,
          min: props.settings.MinValue
        },
        id: props.settings.Name,
        onChange: handleChange
      }), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, props.fieldValue != null ? /*#__PURE__*/React.createElement(React.Fragment, null, isCurrencyFieldSetting(props.settings) ? props.settings.Format || '$' : null, props.fieldValue, props.settings.ShowAsPercentage ? '%' : null) : localization.noValue));
  }
};
//# sourceMappingURL=number.js.map